// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Wesw","large":"styles_large__2Jr7G"};